import React, { useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CustomMaterialTable from "../components/custom_material_table";
import AccountInfoArea from "../components/account_info_area";
import CustomSnackbar from "../components/custom_snackbar";
import { fetchCustomerHistories } from "../services/api";
import Button from "@material-ui/core/Button";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import {
  SYSTEM_DATETIME,
  ENDPOINT_NAME,
  STATUS,
  ERROR_CODE,
  ERROR_MESSAGE,
  TRACE_ID,
} from "../model/customer_hisotires";

const useStyles = makeStyles((theme) => ({
  main: {
    margin: theme.spacing(2),
  },
}));

export default function CustomerHistories(props) {
  const classes = useStyles();
  const {
    branchCode,
    accountNumber,
    cifNo,
    name,
    applicationids,
    setSubtitle,
  } = props;
  const [data, setData] = useState([]);
  const [snackMessage, setSnackMessage] = useState("");
  const [span, setSpan] = useState("");

  const columns = [
    SYSTEM_DATETIME,
    ENDPOINT_NAME,
    STATUS,
    ERROR_CODE,
    ERROR_MESSAGE,
    TRACE_ID,
  ];

  const parseData = (customerHistories) =>
    customerHistories.map((ch) => {
      return { ...ch, status: ch.status < 400 ? "正常" : "異常" };
    });

  const fetchData = useCallback(
    (span) => {
      fetchCustomerHistories(applicationids, span).done((json) => {
        if (json.view_message) return setSnackMessage(json.view_message);

        if (json.error_code) {
          return setSnackMessage(
            `操作ログ情報の取得に失敗しました。 ${json.system_message} `
          );
        }
        setData(parseData(json));
      });
    },
    [applicationids]
  );

  useEffect(
    (span) => {
      setSubtitle("顧客操作ログ画面");
      fetchData(span);
    },
    [applicationids, fetchData, setSubtitle]
  );

  const onSnackbarClose = () => {
    setSnackMessage("");
  };

  const onClickRefreshButton = () => {
    setData([]);
    fetchData(span);
  };

  const handleChangeSpan = (event) => {
    if (/^([1-9]{0,1}|[1-8][0-9]|90)$/.test(event.target.value)) {
      setSpan(event.target.value);
      console.log("event.target.value:" + event.target.value);
    }
  };

  return (
    <>
      <main className={classes.main}>
        <AccountInfoArea
          branchCode={branchCode}
          accountNumber={accountNumber}
          cifNo={cifNo}
          name={name}
          span={span}
          handleChangeSpan={handleChangeSpan}
        />
        <div class="row" style={{ marginBottom: "40px" }}>
          <div class="col-xs-11" />
          <Button
            variant="contained"
            color="primary"
            startIcon={<AutorenewIcon />}
            onClick={onClickRefreshButton}
          >
            更新
          </Button>
        </div>
        <CustomMaterialTable
          columns={columns.map((c) => {
            return {
              title: c.logicalName,
              name: c.key,
            };
          })}
          data={data}
          tableSorting={[
            { columnName: SYSTEM_DATETIME.key, direction: "desc" },
          ]}
          tableColumnExtensions={[
            { columnName: SYSTEM_DATETIME.key, wordWrapEnabled: true },
            { columnName: ENDPOINT_NAME.key, wordWrapEnabled: true },
            { columnName: STATUS.key, wordWrapEnabled: true },
            { columnName: ERROR_CODE.key, wordWrapEnabled: true },
            { columnName: ERROR_MESSAGE.key, wordWrapEnabled: true },
            { columnName: TRACE_ID.key, wordWrapEnabled: true },
          ]}
        />
      </main>
      <CustomSnackbar
        snackMessage={snackMessage}
        onSnackbarClose={onSnackbarClose}
      />
    </>
  );
}
